module.exports = __webpack_public_path__ + "static/media/SOLUS_LR_MARKER_258.75deg.7def9c7f.png";